const WORDS = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve'];
function toWord(n) {
    return n <= 12 ? WORDS[n] : String(n);
}
/**
 * Returns a natural-language relative time string for the given ISO date.
 * Uses the nearest unit: months (≥ 30 days), weeks (≥ 7 days), or days.
 * Examples: "two weeks ago", "in three months", "today".
 */
export function formatRelativeDate(iso) {
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    const target = new Date(iso);
    target.setHours(0, 0, 0, 0);
    const diffMs = target.getTime() - now.getTime();
    const diffDays = Math.round(diffMs / (1000 * 60 * 60 * 24));
    const absDays = Math.abs(diffDays);
    if (absDays === 0)
        return 'today';
    if (absDays === 1)
        return diffDays > 0 ? 'tomorrow' : 'yesterday';
    let value;
    let unit;
    if (absDays >= 30) {
        value = Math.round(absDays / 30);
        unit = value === 1 ? 'month' : 'months';
    }
    else if (absDays >= 7) {
        value = Math.round(absDays / 7);
        unit = value === 1 ? 'week' : 'weeks';
    }
    else {
        value = absDays;
        unit = value === 1 ? 'day' : 'days';
    }
    return diffDays > 0 ? `in ${toWord(value)} ${unit}` : `${toWord(value)} ${unit} ago`;
}
/**
 * Format an ISO date string as a locale date string.
 * Returns '—' for falsy input.
 */
export function formatDate(iso) {
    if (!iso)
        return '—';
    try {
        return new Date(iso).toLocaleDateString();
    }
    catch {
        return iso;
    }
}
/**
 * Returns today's date as an ISO string (YYYY-MM-DD).
 */
export function getTodayISO() {
    return new Date().toISOString().slice(0, 10);
}
